import thunkReducer from '../../../helpers/thunkReducer'
import * as STATES from '../../../constants/states'
import * as actionTypes from './actionTypes'

export default {
  [STATES.MESSAGES_LIST]: thunkReducer(actionTypes.MESSAGES_LIST),
  [STATES.MESSAGES_COUNT]: thunkReducer(actionTypes.MESSAGES_COUNT),
}
